"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var router_1 = require("@angular/router");
/**
 * A route strategy allowing for explicit route reuse.
 * Used as a workaround for https://github.com/angular/angular/issues/18374
 * To reuse a given route, add `data: { reuse: true }` to the route definition.
 */
var RouteReusableStrategy = /** @class */ (function (_super) {
    tslib_1.__extends(RouteReusableStrategy, _super);
    function RouteReusableStrategy() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RouteReusableStrategy.prototype.shouldDetach = function () {
        return false;
    };
    RouteReusableStrategy.prototype.store = function () {
    };
    RouteReusableStrategy.prototype.shouldAttach = function () {
        return false;
    };
    RouteReusableStrategy.prototype.retrieve = function () {
        return null;
    };
    RouteReusableStrategy.prototype.shouldReuseRoute = function (future, curr) {
        return (future.routeConfig === curr.routeConfig) || future.data.reuse;
    };
    return RouteReusableStrategy;
}(router_1.RouteReuseStrategy));
exports.RouteReusableStrategy = RouteReusableStrategy;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicm91dGUtcmV1c2FibGUtc3RyYXRlZ3kuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJyb3V0ZS1yZXVzYWJsZS1zdHJhdGVneS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSwwQ0FBa0c7QUFFbEc7Ozs7R0FJRztBQUNIO0lBQTJDLGlEQUFrQjtJQUE3RDs7SUFxQkEsQ0FBQztJQW5CVSw0Q0FBWSxHQUFuQjtRQUNJLE9BQU8sS0FBSyxDQUFDO0lBQ2pCLENBQUM7SUFFTSxxQ0FBSyxHQUFaO0lBQ0EsQ0FBQztJQUVNLDRDQUFZLEdBQW5CO1FBQ0ksT0FBTyxLQUFLLENBQUM7SUFDakIsQ0FBQztJQUVNLHdDQUFRLEdBQWY7UUFDSSxPQUFPLElBQUksQ0FBQztJQUNoQixDQUFDO0lBRU0sZ0RBQWdCLEdBQXZCLFVBQXdCLE1BQThCLEVBQUUsSUFBNEI7UUFDaEYsT0FBTyxDQUFDLE1BQU0sQ0FBQyxXQUFXLEtBQUssSUFBSSxDQUFDLFdBQVcsQ0FBQyxJQUFJLE1BQU0sQ0FBQyxJQUFJLENBQUMsS0FBSyxDQUFDO0lBQzFFLENBQUM7SUFFTCw0QkFBQztBQUFELENBQUMsQUFyQkQsQ0FBMkMsMkJBQWtCLEdBcUI1RDtBQXJCWSxzREFBcUIifQ==


//////////////////
// WEBPACK FOOTER
// ./src/app/core/route-reusable-strategy.ts
// module id = 618
// module chunks = 0